import {create} from 'zustand';
import {Rect} from '../types';

interface RectStore {
  rects: Rect[];
  setRects: (rects: Rect[]) => void;
  selectRect: (index: number | null) => void;
  addRect: (type: Rect['type']) => void;
  changeRect: (newRect: Partial<Rect>) => void;
  removeRect: () => void;
}

export const useRectStore = create<RectStore>((set) => ({
  rects: [],
  setRects: (rects) => {
    set({rects});
  },
  selectRect: (index: number | null) => {
    set((state) => ({
      rects: state.rects.map((r, i) => ({...r, active: i === index})),
    }));
  },
  addRect: (type: Rect['type']) => {
    set((state) => {
      const img: HTMLImageElement | null = window.document.querySelector(
        'img[data-editor-image="true"]',
      );

      if (!img) {
        return state;
      }

      const width = img.clientWidth < 100 ? img.clientWidth : 100;
      const height = img.clientHeight < 100 ? img.clientHeight : 100;

      const newRect: Rect = {
        active: true,
        width,
        height,
        x: width === img.clientHeight ? 0 : img.clientWidth / 2 - width / 2,
        y: height === img.clientWidth ? 0 : img.clientHeight / 2 - height / 2,
        type,
      };
      return {
        rects: [...state.rects.map((r) => ({...r, active: false})), {...newRect}],
      };
    });
  },
  changeRect: (newRect: Partial<Rect>) => {
    set((state) => ({
      rects: state.rects.map((r) => (r.active ? {...r, ...newRect} : r)),
    }));
  },
  removeRect: () => {
    set((state) => ({
      rects: state.rects.filter((r) => !r.active),
    }));
  },
}));
